import { render, staticRenderFns } from "./CourseFAQListing.vue?vue&type=template&id=b788edb4&"
import script from "./CourseFAQListing.vue?vue&type=script&lang=js&"
export * from "./CourseFAQListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports